import IBranch from './IBranch'
import ISpecie from './ISpecie'

export const PetStatusArray = ['AVAILABLE', 'IN_PROCESS', 'APPROVED', 'ADOPTED'] as const
export type PetStatus = typeof PetStatusArray[number]

export const PetAgeArray = ['BABY', 'SENIOR', 'YOUNG', 'ADULT'] as const
export type PetAge = typeof PetAgeArray[number]

export const PetSexArray = ['FEMALE', 'MALE', 'UNKNOWN'] as const
export type PetSex = typeof PetSexArray[number]

export const PetSizeArray = ['L', 'M', 'XS', 'S', 'XL'] as const
export type PetSize = typeof PetSizeArray[number]

export default interface IPet {
  id?: number,
  uuid: string,
  name: string,
  description: string,
  picture: string,
  sex_key: string,
  size_key: string,
  size_number: number,
  status_key: string,
  age_key: string,
  age_number: number,
  breed_primary_id: number | null,
  breed_secondary_id: number | null,
  specie_id: number | null,
  specie?: ISpecie,
  branch_id: number | null,
  branch?: IBranch,
  neutered: boolean | null,
  mix: boolean | null,
  vaccinated: boolean | null,
  import: boolean | null,
  price: number,
  application_approved_date: string,
  application_adopted_date: string,
  first_application_date: string,
  cycle: number,
  internal_code: number,
  custom_code: number,
  global_code: number,
  verify_again: boolean | null,
  origin_address_id: number | null,
  payment_model_key: string,
  length_stay: string,
  organization_user_id: number | null,
  printed: boolean,
  hidden_uuid: string,
  last_status_update: string,
  archived: boolean,
  active: boolean
}
